import * as React from 'react';
import * as i18n from 'i18next';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { setSelectedPollId, setPollStatus } from 'redux/modules/polls/managepoll';
import {
	getPolls,
	deletePoll,
	setPollsStatusFilter,
	setPollsSearchFilter,
	setPollsSortFilter,
	setPollItemsPage,
	resetPollsData,
	resetPollsFilters,
	setPollsIsFirstLoad,
} from 'redux/modules/polls/polls';
import { closeModal, showModal } from 'redux/modules/modal';
import * as c from 'models/constants';
import { IPollsData, IPollsAction } from 'models/polls/polls';
import { IModalAction } from 'models/modal';
import { IPage } from 'models/common';
import { IManagePoll } from 'models/polls/managepoll';
import { PollStatus } from 'models/enums/statuses';
import { ItemCardList } from 'components';
import { ErrorPage } from 'containers';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { IItemCardList } from 'models/itemcard';
import { IUserPreferences } from 'models/user/userpreferences';
import { FilteredPage } from 'components/PortalStructure';

interface IProps {
	pollsData?: IPollsData;
	managePoll?: IManagePoll;
	userPreferences?: IUserPreferences;
	getPolls?: () => IPollsAction;
	deletePoll?: (itemId: string) => IPollsAction;
	setPollStatus?: (id: string, status: PollStatus) => IPollsAction;
	setPollsStatusFilter?: (status: number) => IPollsAction;
	setPollsSearchFilter?: (keyword: string) => IPollsAction;
	setPollsSortFilter?: (keyword: string) => IPollsAction;
	setPollItemsPage?: (page: IPage) => IPollsAction;
	setSelectedPollId: (id: string) => IPollsAction;
	resetPollsData?: () => IPollsAction;
	resetPollsFilters?: () => IPollsAction;
	setPollsIsFirstLoad?: (isFirstLoad: boolean) => IPollsAction;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
}

interface IAdminPollsItemCardList extends IItemCardList {
	archiveItem?: (itemType: string, itemId: string) => void;
}

@connect(
	(state: IStore) => ({
		pollsData: state.polls,
		managePoll: state.managePoll,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		getPolls: () => dispatch(getPolls()),
		deletePoll: (id: string) => dispatch(deletePoll(id)),
		setPollsStatusFilter: (status: string) => dispatch(setPollsStatusFilter(status)),
		setPollsSearchFilter: (keyword: string) => dispatch(setPollsSearchFilter(keyword)),
		setPollsSortFilter: (sort: string) => dispatch(setPollsSortFilter(sort)),
		setPollItemsPage: (page: IPage) => dispatch(setPollItemsPage(page)),
		setSelectedPollId: (id: string) => dispatch(setSelectedPollId(id)),
		setPollStatus: (id: string, status: PollStatus) => dispatch(setPollStatus(id, status)),
		resetPollsData: () => dispatch(resetPollsData()),
		resetPollsFilters: () => dispatch(resetPollsFilters()),
		setPollsIsFirstLoad: (isFirstLoad: boolean) => dispatch(setPollsIsFirstLoad(isFirstLoad)),
		showModal: (type: string, modalProps: any) => dispatch(showModal(type, modalProps)),
		closeModal: () => dispatch(closeModal()),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminPolls extends React.Component<IProps> {
	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
		this.openDeletePoll = this.openDeletePoll.bind(this);
		this.openArchivePoll = this.openArchivePoll.bind(this);
		this.deletePoll = this.deletePoll.bind(this);
		this.archivePoll = this.archivePoll.bind(this);
		this.editItem = this.editItem.bind(this);
		this.handleStatusChange = this.handleStatusChange.bind(this);
		this.handleSearchEnterPress = this.handleSearchEnterPress.bind(this);
		this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
		this.searchPolls = this.searchPolls.bind(this);
	}

	public componentDidMount() {
		this.props.resetPollsFilters();
		this.props.setPollsIsFirstLoad(true);
		this.props.getPolls();
	}

	public componentWillUnmount() {
		this.props.resetPollsFilters();
		this.props.resetPollsData();
	}

	public loadMoreData() {
		this.props.getPolls();
	}

	public handleStatusChange(value: number) {
		this.props.setPollsStatusFilter(value);
		this.props.getPolls();
	}

	private handleSearchEnterPress() {
		this.props.getPolls();
	}

	private handleSearchValueChange(value: string) {
		this.props.setPollsSearchFilter(value);
	}

	private searchPolls() {
		this.props.getPolls();
	}

	private openEditPoll() {
		this.props.showModal('ManagePoll', {
			closeModal: this.props.closeModal,
			showModal: this.props.showModal,
			showHeaderCloseButton: true,
		});
	}

	public editItem(id: string) {
		const poll = this.props.pollsData.items.filter((x) => x.id === id)[0];
		if (poll.status === PollStatus.Approved || poll.status === PollStatus.Archived) {
			alert(this.props.t('Polls_Admin_CannotEdit'));
			return;
		}

		this.props.setSelectedPollId(id);
		this.openEditPoll();
	}

	private openDeletePoll(_, id: string) {
		const dialogContent = (
			<div>
				<img src={require('containers/Html/icons/icon_notification.png')} />
				<h2>{i18n.t('BSPortal_Common_ConfirmationDialog_Sure')}</h2>
				<p>{i18n.t('Magazine_AdminArticles_DeleteModal_Label_AboutDelete')}</p>
				<p>{i18n.t('BSPortal_Common_ConfirmationDialog_Confirm')}</p>
			</div>
		);

		this.props.showModal('ConfirmationDialog', {
			confirmAction: this.deletePoll,
			value: id,
			yesButtonText: i18n.t('BSPortal_Common_YesDelete'),
			noButtonText: i18n.t('BSPortal_Common_NoWait'),
			content: dialogContent,
			closeModal: this.props.closeModal,
		});
	}

	private deletePoll(confirm: boolean, id: string) {
		if (confirm) {
			this.props.deletePoll(id);
		}
		this.props.closeModal();
	}

	private openArchivePoll(id: string) {
		const poll = this.props.pollsData.items.filter((x) => x.id === id)[0];
		if (poll.status === PollStatus.Archived) {
			alert(this.props.t('Polls_Admin_CannotArchive'));
			return;
		}

		const dialogContent = (
			<div>
				<img src={require('containers/Html/icons/icon_notification.png')} />
				<h2>{i18n.t('BSPortal_Common_ConfirmationDialog_Hey')}</h2>
				<p>{i18n.t('Polls_Admin_ArchiveModal_Label_AboutArchive')}</p>
				<p>{i18n.t('BSPortal_Common_ConfirmationDialog_Confirm')}</p>
			</div>
		);

		this.props.showModal('ConfirmationDialog', {
			confirmAction: this.archivePoll,
			value: id,
			yesButtonText: i18n.t('BSPortal_Common_Yes'),
			noButtonText: i18n.t('BSPortal_Common_NoWait'),
			content: dialogContent,
			closeModal: this.props.closeModal,
		});
	}

	private archivePoll(confirm: boolean, id: string) {
		if (confirm) {
			this.props.setPollStatus(id, PollStatus.Archived);
		}
		this.props.closeModal();
	}

	public render() {
		if (this.props.pollsData.error) {
			return <ErrorPage {...this.props} message={this.props.pollsData.message} />;
		}

		const { items, keywordFilter, statusFilter, itemsPage } = this.props.pollsData;
		const { t } = this.props;

		const statusesOptions = [];
		for (const n in PollStatus) {
			if (typeof PollStatus[n] === 'number') {
				statusesOptions.push({ key: PollStatus[n], value: t('CodeList_PollStatus_' + PollStatus[n]) });
			}
		}

		let polls = [];

		if (this.props.pollsData !== undefined || this.props.pollsData !== null) {
			polls = this.props.pollsData.items;
		}

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: itemsPage.totalItems > items.length,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const listProps: IAdminPollsItemCardList = {
			items: polls,
			itemType: c.NODE_TYPE_ADMIN_POLL_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			useIntersectionObserver: true,
			editItem: this.editItem,
			deleteItem: this.openDeletePoll,
			archiveItem: this.openArchivePoll,
			currentUserId: this.props.userPreferences.id,
			currentUserIsAdministrator: this.props.userPreferences.isAdministrator,
			currentUserIsEditor: this.props.userPreferences.isEditor,
		};

		const topBarProps: object = {
			searchKeyword: keywordFilter,
			leftFilterTitle: t('BSPortal_Common_Filter_Status'),
			leftFilterKey: statusFilter,
			leftFilterOptions: statusesOptions,
			onSearchButtonClick: this.searchPolls,
			onSearchEnterPress: this.handleSearchEnterPress,
			onSearchValueChange: this.handleSearchValueChange,
			onLeftFilterChange: this.handleStatusChange,
		};

		return (
			<FilteredPage filterBarOptions={topBarProps} childIsList={false}>
				<ItemCardList {...listProps} />
			</FilteredPage>
		);
	}
}
export { AdminPolls };
